import { COURSE_STATUS } from '@/constants/course-status'

export function getCourseStatusById(statusId: string) {
  const entries = Object.values(COURSE_STATUS)
  const found = entries.find((entrie) => entrie.id === statusId)
  return found?.label || '--'
}
